<div *ngIf="!chatState.token(); else haveToken" class="page-wrapper">
  <mat-card class="welcome-box" appearance="outlined">
    <mat-card-header class="messaging-header"> Messaging Module </mat-card-header>
    <mat-card-content class="messaging-content">
      <h4>Option 1</h4>
      <b>Post configuration and authentication token directly</b>
      <p>You can post this data directly to the module and launch messaging that way.</p>
      <p><b>Example:</b></p>
      <pre>{{ example }}</pre>
      <hr />
      <h4>Option 2</h4>
      <b>Load messaging and log in using your bNOTES credentials</b>
      <p>
        You will be asked to provide your name, along with the name and phone number of your
        intended recipient.
      </p>
    </mat-card-content>
    <mat-card-actions class="messaging-actions">
      <div class="button-group">
        <button mat-raised-button class="styled-button" routerLink="/messaging">Log In</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
<ng-template #haveToken>
  <div *ngIf="!chatState.recipient()" class="no-phone-content">
    The patient does not have a mobile phone number
  </div>
</ng-template>
<router-outlet></router-outlet>
